import { schema } from "normalizr"

export const ENTITY_CONTACTS = 'contacts'
export const ENTITY_CONTACTS_LIST = 'contactsList'

export const contactsSchema = new schema.Entity(ENTITY_CONTACTS)
export const contactsListSchema = new schema.Entity(
  ENTITY_CONTACTS_LIST,
  {
    contacts: [contactsSchema]
  },
  { idAttribute: () => 'list' }
)
